import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import InputField from '../InputField';

function ItemCodeInputField({
  grid,
  defaultValue,
  borderradius,
  border,
  padding,
  bgcolor,
  fontsize,
  handleChange,
}) {
  const { t } = useTranslation();

  return (
    <InputField
      name="item-code"
      type="text"
      grid={grid}
      defaultValue={defaultValue}
      placeholder={t('Item code')}
      borderradius={borderradius}
      border={border}
      padding={padding}
      bgcolor={bgcolor}
      fontsize={fontsize}
      label={t('Item code')}
      handleChange={handleChange}
    />
  );
}

ItemCodeInputField.propTypes = {
  grid: PropTypes.number,
  padding: PropTypes.string,
  borderradius: PropTypes.number,
  fontsize: PropTypes.number,
  bgcolor: PropTypes.string,
  border: PropTypes.string,
  defaultValue: PropTypes.string,
  handleChange: PropTypes.func,
};

ItemCodeInputField.defaultProps = {
  grid: 12,
  padding: '',
  borderradius: 0,
  fontsize: 12,
  bgcolor: '#fff',
  border: '',
  defaultValue: '',
};

export default ItemCodeInputField;
